import {SoftDeleteEntity} from './soft-delete-entity';
import {IdentStatus} from './ident-status';
import {AppIdentityUserLight} from './app-identity-user-light';
import {PepStatus} from './pep-status';

import {IdentTransactionFile} from './ident-transaction-file';

export class WebIdTransaction extends SoftDeleteEntity {
  public status: IdentStatus;
  public pepStatus: PepStatus;
  public finishedOn: Date|null;
  public identifiedOn: Date|null;
  public creationDate: Date;
  public responseFileId: number;
  public url: string;
  public providerCode: number;

  public bioDataFirstName: string;
  public bioDataLastName: string;
  public bioDataDob: Date;

  public documentType: string|null;
  public documentNumber: string|null;
  public documentCountry: string|null;
  public documentValidFrom: Date|null;
  public documentValidUntil: Date|null;
}

export class IdentContainer {
  public ident: WebIdTransaction;
  public files: IdentTransactionFile[]|null;
}
